// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AAdP","input":"styles_input__3Kb5y"};